import React, { useState } from 'react';
import TeamSetup from './components/TeamSetup';
import LetterGrid from './components/LetterGrid';
import QuestionPanel from './components/QuestionPanel';
import AnswerControls from './components/AnswerControls';
import GameOverScreen from './components/GameOverScreen';
import StartScreen from './components/StartScreen';
import './style.css';

import pointSound from './assets/sounds/point.mp3';
const pointAudio = new Audio(pointSound);


function App() {
  const [teams, setTeams] = useState(null);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState('');
  const [answered, setAnswered] = useState(false);
  const [usedLetters, setUsedLetters] = useState([]);
  const [showStartScreen, setShowStartScreen] = useState(true);

  const isGameOver = usedLetters.length === 20;

  const startGame = (teamNames) => {
    const teamData = teamNames.map(name => ({ name, score: 0 }));
    setTeams(teamData);
  };

  const handleLetterSelect = (letter) => {
    setSelectedLetter(letter);
    setCurrentQuestion('');
    setAnswered(false);
    setUsedLetters([...usedLetters, letter]);
  };

  const handleTeamAnswered = (teamIndex) => {
    const updatedTeams = [...teams];
    updatedTeams[teamIndex].score += 1;
    setTeams(updatedTeams);
    setAnswered(true);
    pointAudio.play();
  };

  const handleNoAnswer = () => {
    setAnswered(true);
  };

  const handleNext = () => {
    setSelectedLetter(null);
    setCurrentQuestion('');
    setAnswered(false);
  };

  return (
    <div className="App">
      
      {showStartScreen ? (
        <StartScreen onStart={() => setShowStartScreen(false)} />
      ) : !teams ? (
        <TeamSetup onStart={startGame} />
      ) : isGameOver ? (
        <GameOverScreen teams={teams} onRestart={() => window.location.reload()} />
      ) : !selectedLetter ? (
        <LetterGrid
          onLetterSelect={handleLetterSelect}
          usedLetters={usedLetters}
        />
      ) : (
        <>
          <QuestionPanel
            letter={selectedLetter}
            onQuestionReady={setCurrentQuestion}
          />
          {!answered ? (
            <AnswerControls
              teams={teams}
              onTeamAnswered={handleTeamAnswered}
              onNoAnswer={handleNoAnswer}
            />
          ) : (
            <div className="text-center mt-4">
              <p className="mb-2 text-green-700 font-bold">تم تسجيل النتيجة!</p>
              <button
  onClick={handleNext}
  className="next-button"
>
  لغز آخر 🔁
</button>


            </div>
          )}

          {/* عرض النقاط */}
          <div className="p-4 mt-4 bg-gray-100">
            <h3 className="text-center font-bold mb-2">النقاط الحالية:</h3>
            <ScoreDisplay
              scores={teams.reduce(
                (acc, team) => ({ ...acc, [team.name]: team.score }),
                {}
              )}
            />
          </div>
        </>
      )}
    </div>
  );
}

function ScoreDisplay({ scores }) {
  return (
    <div className="score-container">
      {Object.entries(scores).map(([team, score]) => (
        <div key={team} className="score-row">
          <span className="team-name">{team}</span>
          <span className="score-value">{score}</span>
        </div>
      ))}
    </div>
  );
}


export default App;
